export const REQUIRED_MSG = 'Required'

export const required = value => value ? undefined : REQUIRED_MSG
export const email = value => value && !/^[A-Z0-9'._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)
? true : undefined